
export default function PageHeading (props: any) {
  return (
    <div className="w-full mx-auto py-4 px-6 flex grow">
      <h2 className="text-lg leading-6 font-semibold text-gray-100">{props.title}</h2>
    </div>
  );
}
